import { Box, Typography } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

type Props = {
  isLoading?: boolean;
};

const EmptyMessage: React.FC<Props> = ({ isLoading = false }: Props) => {
  const { colors } = useCelleraTheme();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        flex: 1,
        alignSelf: "center",
      }}
    >
      <Typography variant="body1" sx={{ color: colors.text.secondary }}>
        {isLoading ? "Loading messages..." : "No messages here yet..."}
      </Typography>
    </Box>
  );
};

export default EmptyMessage;
